/**
 * Landing page copy: English (default) and French.
 * Keys use dot notation (e.g. nav.joinWaitlist).
 */

const en = {
  nav: {
    joinWaitlist: 'Join Waitlist',
    aboutUs: 'About Us',
    backHome: '← Home',
    home: 'Home',
    langToggle: 'Language',
    menu: 'Open menu',
    menuClose: 'Close menu',
    logoTagline: 'PAYMENTS SUPER APP',
  },
  hero: {
    badge: 'Early Beta · Launching Soon',
    line1: 'Pay anywhere',
    line2: 'across Morocco.',
    sub1: 'Send dirhams, scan QR codes, top up instantly.',
    sub2: 'No cash, no friction, no waiting.',
  },
  phone: {
    walletBalance: 'Wallet Balance',
    thisMonth: 'This month',
    send: 'Send',
    receive: 'Receive',
    topUp: 'Top Up',
    scanQr: 'Scan QR',
    recent: 'Recent',
    seeAll: 'See all',
    simopayLine: 'SimoPay · just now',
    amount: 'Amount',
    sendNow: 'Send Now →',
    zeroFees: 'Zero fees · Instant',
    sendMoney: 'Send Money',
    searchPlaceholder: 'Search by name or @SimoID',
    select: '✓ Select',
    topUpWallet: 'Top Up Wallet',
    currentBalance: 'Current Balance',
    selectAmount: 'Select amount',
    payVia: 'Pay via',
    instant: 'Instant',
    underOneMin: '<1 min',
    topUpCta: 'Top Up 500 MAD ↑',
    scanPay: 'Scan & Pay',
    pointCamera: 'Point camera at a merchant QR code',
    or: 'OR',
    myQr: 'My QR Code',
    time: {
      justNow: 'just now',
      h1: '1h ago',
      h2: '2h ago',
      h3: '3h ago',
    },
    dateFallback: '27 Jan 2026',
  },
  txPool: {
    youssef: 'Youssef El Amrani',
    cafeBahia: 'Cafè El Bahia',
    cihTopUp: 'CIH Bank Top Up',
    mariam: 'Mariam Idrissi',
    hassan: 'Hassan Benali',
    souk: 'Souk El Medina',
    taxi: 'Taxi Marrakech',
    fatima: 'Fatima Zahra',
    barid: 'Barid Al Maghrib',
    restaurant: 'Restaurant Nid',
    omar: 'Omar Alaoui',
    marjane: 'Marjane',
    cafeBoulevard: 'Café Boulevard',
    topUpCard: 'Top Up · Card',
  },
  services: {
    h1: 'Everything you need,',
    h2: 'all in one app.',
    sub: 'The first app built for Morocco that combines digital payments with everyday services.',
    galleryReadMore: 'Learn more',
    qr:     { name: 'QR Payments',       desc: 'Scan to pay at any merchant across Morocco instantly.' },
    wallet: { name: 'Wallet & Payments', desc: 'Your MAD wallet: send, receive, top up in seconds.' },
    taxi:   { name: 'Book a Taxi',       desc: 'Hail a ride anywhere in Morocco from the app.' },
    food:   { name: 'Food Delivery',     desc: 'Order from local restaurants delivered to your door.' },
    car:    { name: 'Car Rental',        desc: 'Rent a car for a day or a week, paid with your wallet.' },
    esim:   { name: 'eSIM',              desc: 'Buy local data plans without a physical SIM card.' },
  },
  appExperience: {
    marketBadge1: 'EU',
    marketBadge2: 'MA',
    marketBadge3: 'Global',
    trustPill1: 'MAD',
    trustPill2: 'QR',
    trustPill3: 'Banks',
    step0: {
      headline1: 'Scan to pay',
      headline2: 'anywhere in Morocco.',
      sub: 'Show your QR or scan a merchant code at souks, cafés, and riads across Morocco.',
      f1: 'Works at 10,000+ merchants',
      f2: 'Offline QR generation',
      f3: 'Souks, riads, cafés & more',
      f4: 'Accepts any Moroccan QR',
    },
    step1: {
      headline1: 'Book, eat, rent',
      headline2: 'all in the app.',
      sub: 'One app for taxis, food delivery, and car rentals, paid from your dirham wallet.',
      f1: 'Hail a taxi in seconds',
      f2: 'Food from local restaurants',
      f3: 'Car rentals, day or week',
      f4: 'All paid from your wallet',
    },
    step2: {
      headline1: 'All your money.',
      headline2: 'Perfectly synced.',
      sub: 'Your Simo Pay wallet updates in real time. Every dirham accounted for, right in your pocket.',
      f1: 'Real time balance updates',
      f2: 'Cash, Saving & Card breakdown',
      f3: 'Instant transaction history',
      f4: 'End to end encrypted',
    },
  },
  waitlist: {
    title1: 'Be first in',
    title2: "Morocco's super app.",
    body: 'Pay, ride, eat, rent, and connect, all from one app. Get exclusive founder benefits when we launch in 2026.',
    successTitle: "You're on the list!",
    successBody: "We'll reach out when SimoPay launches in Morocco.",
    formTitle: 'Join the waitlist',
    formSubtitle: 'Get notified the moment we launch.',
    emailLabel: 'Email address',
    emailPlaceholder: 'you@example.com',
    errInvalid: 'Please enter a valid email.',
    errGeneric: 'Could not join waitlist right now. Please try again.',
    joining: 'Joining…',
    cta: 'Get Early Access →',
  },
  footer: {
    rights: '© 2026 SIMO Pay. All rights reserved.',
    builtFor: 'Built For Morocco',
  },
};

const fr = {
  nav: {
    joinWaitlist: "Rejoindre la liste d'attente",
    aboutUs: 'Qui sommes nous',
    backHome: '← Accueil',
    home: 'Accueil',
    langToggle: 'Langue',
    menu: 'Ouvrir le menu',
    menuClose: 'Fermer le menu',
    logoTagline: 'SUPER APP PAIEMENTS',
  },
  hero: {
    badge: 'Bêta · Lancement imminent',
    line1: 'Payez partout',
    line2: 'au Maroc.',
    sub1: 'Envoyez des dirhams, scannez QR, recharge instantanée.',
    sub2: 'Sans cash, sans friction, sans attente.',
  },
  phone: {
    walletBalance: 'Solde du portefeuille',
    thisMonth: 'Ce mois ci',
    send: 'Envoyer',
    receive: 'Recevoir',
    topUp: 'Recharger',
    scanQr: 'Scanner QR',
    recent: 'Récent',
    seeAll: 'Tout voir',
    simopayLine: "SimoPay · à l'instant",
    amount: 'Montant',
    sendNow: 'Envoyer →',
    zeroFees: 'Sans frais · Instantané',
    sendMoney: "Envoyer de l'argent",
    searchPlaceholder: 'Rechercher par nom ou @SimoID',
    select: '✓ Choisir',
    topUpWallet: 'Recharger le portefeuille',
    currentBalance: 'Solde actuel',
    selectAmount: 'Choisir le montant',
    payVia: 'Payer via',
    instant: 'Instantané',
    underOneMin: '<1 min',
    topUpCta: 'Recharger 500 MAD ↑',
    scanPay: 'Scanner et payer',
    pointCamera: 'Pointez la caméra vers le QR du commerçant',
    or: 'OU',
    myQr: 'Mon code QR',
    time: {
      justNow: "à l'instant",
      h1: 'il y a 1 h',
      h2: 'il y a 2 h',
      h3: 'il y a 3 h',
    },
    dateFallback: '27 janv. 2026',
  },
  txPool: {
    youssef: 'Youssef El Amrani',
    cafeBahia: 'Cafè El Bahia',
    cihTopUp: 'Recharge CIH Bank',
    mariam: 'Mariam Idrissi',
    hassan: 'Hassan Benali',
    souk: 'Souk El Medina',
    taxi: 'Taxi Marrakech',
    fatima: 'Fatima Zahra',
    barid: 'Barid Al Maghrib',
    restaurant: 'Restaurant Nid',
    omar: 'Omar Alaoui',
    marjane: 'Marjane',
    cafeBoulevard: 'Café Boulevard',
    topUpCard: 'Recharge · Carte',
  },
  services: {
    h1: 'Tout ce dont vous avez besoin,',
    h2: 'en une seule app.',
    sub: 'La première app conçue pour le Maroc combinant paiements numériques et services du quotidien.',
    galleryReadMore: 'En savoir plus',
    qr:     { name: 'Paiements QR',            desc: "Scannez pour payer chez n'importe quel commerçant au Maroc." },
    wallet: { name: 'Portefeuille & Paiements', desc: 'Votre wallet MAD: envoyez, recevez, rechargez en secondes.' },
    taxi:   { name: 'Réserver un Taxi',        desc: "Commandez une course partout au Maroc depuis l'app." },
    food:   { name: 'Livraison de Repas',      desc: 'Commandez chez les restaurants locaux livrés chez vous.' },
    car:    { name: 'Location de Voiture',     desc: 'Louez une voiture à la journée ou à la semaine.' },
    esim:   { name: 'eSIM',                    desc: 'Achetez des forfaits data locaux sans carte SIM physique.' },
  },
  appExperience: {
    marketBadge1: 'UE',
    marketBadge2: 'MA',
    marketBadge3: 'Monde',
    trustPill1: 'MAD',
    trustPill2: 'QR',
    trustPill3: 'Banques',
    step0: {
      headline1: 'Scannez pour payer',
      headline2: 'partout au Maroc.',
      sub: "Montrez votre QR ou scannez le code d'un commerçant dans les souks, cafés et riads du Maroc.",
      f1: 'Plus de 10 000 commerçants',
      f2: 'Génération de QR hors ligne',
      f3: 'Souks, riads, cafés et plus',
      f4: 'Accepte tout QR marocain',
    },
    step1: {
      headline1: 'Réservez, mangez, louez',
      headline2: "tout dans l'app.",
      sub: 'Une app pour les taxis, la livraison et la location de voitures, payée depuis votre wallet.',
      f1: 'Un taxi en quelques secondes',
      f2: 'Repas des restaurants locaux',
      f3: 'Location de voiture, jour ou semaine',
      f4: 'Tout payé depuis votre wallet',
    },
    step2: {
      headline1: 'Tout votre argent.',
      headline2: 'Parfaitement synchronisé.',
      sub: 'Votre portefeuille Simo Pay se met à jour en temps réel. Chaque dirham compté, dans votre poche.',
      f1: 'Mise à jour du solde en temps réel',
      f2: 'Répartition Espèces, Épargne et Carte',
      f3: 'Historique des transactions instantané',
      f4: 'Chiffrement de bout en bout',
    },
  },
  waitlist: {
    title1: 'Soyez les premiers dans',
    title2: 'la super app du Maroc.',
    body: 'Payer, se déplacer, manger, louer et se connecter, tout en une app. Obtenez des avantages fondateurs exclusifs à notre lancement en 2026.',
    successTitle: 'Vous êtes sur la liste !',
    successBody: 'Nous vous contacterons au lancement de SimoPay au Maroc.',
    formTitle: "Rejoindre la liste d'attente",
    formSubtitle: 'Soyez averti dès notre lancement.',
    emailLabel: 'Adresse email',
    emailPlaceholder: 'vous@exemple.com',
    errInvalid: 'Veuillez saisir une adresse email valide.',
    errGeneric: 'Impossible de rejoindre la liste pour le moment. Réessayez.',
    joining: 'Inscription…',
    cta: 'Accès anticipé →',
  },
  footer: {
    rights: '© 2026 SIMO Pay. Tous droits réservés.',
    builtFor: 'Pensé pour le Maroc',
  },
};

const ar = {
  nav: {
    joinWaitlist: 'انضم إلى قائمة الانتظار',
    aboutUs: 'من نحن',
    backHome: '→ الرئيسية',
    home: 'الرئيسية',
    langToggle: 'اللغة',
    menu: 'فتح القائمة',
    menuClose: 'إغلاق القائمة',
    logoTagline: 'تطبيق المدفوعات الشامل',
  },
  hero: {
    badge: 'إصدار تجريبي · الإطلاق قريباً',
    line1: 'ادفع في أي مكان',
    line2: 'عبر المغرب.',
    sub1: 'أرسل الدراهم، امسح رموز QR، اشحن فوراً.',
    sub2: 'بلا نقد، بلا تعقيد، بلا انتظار.',
  },
  phone: {
    walletBalance: 'رصيد المحفظة',
    thisMonth: 'هذا الشهر',
    send: 'إرسال',
    receive: 'استقبال',
    topUp: 'شحن',
    scanQr: 'مسح QR',
    recent: 'الأخيرة',
    seeAll: 'عرض الكل',
    simopayLine: 'سيمو باي · الآن',
    amount: 'المبلغ',
    sendNow: 'إرسال الآن →',
    zeroFees: 'بدون رسوم · فوري',
    sendMoney: 'إرسال الأموال',
    searchPlaceholder: 'ابحث بالاسم أو @SimoID',
    select: '✓ اختيار',
    topUpWallet: 'شحن المحفظة',
    currentBalance: 'الرصيد الحالي',
    selectAmount: 'اختر المبلغ',
    payVia: 'الدفع عبر',
    instant: 'فوري',
    underOneMin: 'أقل من دقيقة',
    topUpCta: 'شحن 500 درهم ↑',
    scanPay: 'مسح والدفع',
    pointCamera: 'وجّه الكاميرا نحو رمز QR الخاص بالتاجر',
    or: 'أو',
    myQr: 'رمز QR الخاص بي',
    time: {
      justNow: 'الآن',
      h1: 'منذ ساعة',
      h2: 'منذ ساعتين',
      h3: 'منذ 3 ساعات',
    },
    dateFallback: '27 يناير 2026',
  },
  txPool: {
    youssef: 'يوسف العمراني',
    cafeBahia: 'مقهى الباهية',
    cihTopUp: 'شحن بنك CIH',
    mariam: 'مريم إدريسي',
    hassan: 'حسن بن علي',
    souk: 'سوق المدينة',
    taxi: 'تاكسي مراكش',
    fatima: 'فاطمة الزهراء',
    barid: 'بريد المغرب',
    restaurant: 'مطعم نيد',
    omar: 'عمر العلوي',
    marjane: 'مرجان',
    cafeBoulevard: 'مقهى البوليفار',
    topUpCard: 'شحن · بطاقة',
  },
  services: {
    h1: 'كل ما تحتاجه،',
    h2: 'في تطبيق واحد.',
    sub: 'أول تطبيق مصمم للمغرب يجمع بين المدفوعات الرقمية وخدمات الحياة اليومية.',
    galleryReadMore: 'اعرف أكثر',
    qr:     { name: 'مدفوعات QR',         desc: 'امسح للدفع لدى أي تاجر عبر المغرب فوراً.' },
    wallet: { name: 'المحفظة والمدفوعات', desc: 'محفظة الدراهم: أرسل، استقبل، اشحن في ثوانٍ.' },
    taxi:   { name: 'احجز تاكسي',         desc: 'استأجر سيارة في أي مكان بالمغرب من التطبيق.' },
    food:   { name: 'توصيل الطعام',        desc: 'اطلب من المطاعم المحلية ويُوصَّل إلى بابك.' },
    car:    { name: 'تأجير السيارات',      desc: 'استأجر سيارة ليوم أو أسبوع، مدفوعة من محفظتك.' },
    esim:   { name: 'شريحة eSIM',          desc: 'اشتر باقات البيانات المحلية بدون شريحة مادية.' },
  },
  appExperience: {
    marketBadge1: 'الاتحاد الأوروبي',
    marketBadge2: 'المغرب',
    marketBadge3: 'عالمي',
    trustPill1: 'درهم',
    trustPill2: 'QR',
    trustPill3: 'البنوك',
    step0: {
      headline1: 'امسح للدفع',
      headline2: 'في أي مكان بالمغرب.',
      sub: 'اعرض رمز QR الخاص بك أو امسح رمز التاجر في الأسواق والمقاهي والرياض عبر المغرب.',
      f1: 'يعمل لدى أكثر من 10,000 تاجر',
      f2: 'توليد QR بدون إنترنت',
      f3: 'أسواق، رياض، مقاهٍ والمزيد',
      f4: 'يقبل أي رمز QR مغربي',
    },
    step1: {
      headline1: 'احجز، كُل، استأجر',
      headline2: 'كل ذلك في التطبيق.',
      sub: 'تطبيق واحد للتاكسي وتوصيل الطعام وتأجير السيارات، مدفوع من محفظة الدراهم.',
      f1: 'استأجر تاكسي في ثوانٍ',
      f2: 'طعام من مطاعم محلية',
      f3: 'تأجير سيارات، يوم أو أسبوع',
      f4: 'كل شيء مدفوع من محفظتك',
    },
    step2: {
      headline1: 'كل أموالك.',
      headline2: 'متزامنة تماماً.',
      sub: 'تتحدث محفظة سيمو باي في الوقت الفعلي. كل درهم محسوب، في جيبك.',
      f1: 'تحديثات الرصيد الفوري',
      f2: 'توزيع النقد والادخار والبطاقة',
      f3: 'سجل المعاملات اللحظي',
      f4: 'تشفير من طرف إلى طرف',
    },
  },
  waitlist: {
    title1: 'كن الأول في',
    title2: 'التطبيق الشامل للمغرب.',
    body: 'ادفع، تنقّل، كُل، استأجر وتواصل، كل ذلك من تطبيق واحد. احصل على مزايا المؤسسين الحصرية عند إطلاقنا في 2026.',
    successTitle: 'أنت في القائمة!',
    successBody: 'سنتواصل معك عند إطلاق سيمو باي في المغرب.',
    formTitle: 'انضم إلى قائمة الانتظار',
    formSubtitle: 'احصل على إشعار فور إطلاقنا.',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'you@example.com',
    errInvalid: 'يرجى إدخال بريد إلكتروني صحيح.',
    errGeneric: 'تعذّر الانضمام إلى قائمة الانتظار الآن. يرجى المحاولة مجدداً.',
    joining: 'جارٍ التسجيل…',
    cta: 'الحصول على وصول مبكر →',
  },
  footer: {
    rights: '© 2026 SIMO Pay. جميع الحقوق محفوظة.',
    builtFor: 'مصنوع من أجل المغرب',
  },
};

export const landingLocales = ['en', 'fr', 'ar'];

export const landingCopy = { en, fr, ar };
